import { PMS_PRODUCT_STOCK_STATUS } from 'commons/options';
import type { ProductUpdateInfoNewType } from 'types/pms';

export const appendProductRemarkLine = (
  remark: string | undefined,
  date: string,
  label: string,
) => {
  const nextLine = `${date} ${label}`;
  const currentRemark = remark?.trimEnd();
  return currentRemark ? `${currentRemark}\n${nextLine}` : nextLine;
};

export const getLentOutRemarkDisplay = (
  stockStatus: string | undefined,
  remark: string | undefined,
) => {
  if (stockStatus !== PMS_PRODUCT_STOCK_STATUS.LENT_OUT) return '';
  return remark?.trim() || '';
};

export const updateProductsWithMaintenanceRemark = async ({
  productIdList,
  getProductUpdateInfo,
  updateProductRemark,
  date,
  label,
}: {
  productIdList: number[];
  getProductUpdateInfo: (
    productId: number,
  ) => Promise<Pick<ProductUpdateInfoNewType, 'remark'>>;
  updateProductRemark: (productId: number, remark: string) => Promise<unknown>;
  date: string;
  label: string;
}) => {
  await Promise.all(
    productIdList.map(async (productId) => {
      const productDetail = await getProductUpdateInfo(productId);
      const remark = appendProductRemarkLine(productDetail.remark, date, label);

      await updateProductRemark(productId, remark);
    }),
  );
};
